import { Typography } from '@material-ui/core';
import { Inline, Stack } from '@superdispatch/ui';
import { formatAddressLine } from 'shared/helpers/AddressHelpers';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import {
  PostingLoadEditsDTO,
  PostingLoadEditsVenueDTO,
} from '../../data/dto/PostingDTO';

interface PostingEditedChangesProps {
  loadEdits: PostingLoadEditsDTO | null;
}

interface EditedChange {
  label: string;
  value: string;
}

export function PostingEditedChanges({ loadEdits }: PostingEditedChangesProps) {
  const changes = getEditedChanges(loadEdits);

  if (changes.length === 0) {
    return null;
  }

  return (
    <Stack space="xxsmall">
      {changes.map(({ label, value }) => (
        <Inline key={label} space="xxsmall">
          <Typography color="textSecondary">{label}</Typography>
          <Typography variant="body1">{value}</Typography>
        </Inline>
      ))}
    </Stack>
  );
}

function getEditedChanges(
  loadEdits: PostingLoadEditsDTO | null,
): EditedChange[] {
  return [
    {
      label: 'Pickup was',
      value: formatVenue(loadEdits?.previous_pickup_venue),
    },
    {
      label: 'Delivery was',
      value: formatVenue(loadEdits?.previous_delivery_venue),
    },
    {
      label: 'Price was',
      value:
        loadEdits?.previous_price == null
          ? ''
          : formatCurrency(loadEdits.previous_price, {
              maximumFractionDigits: 0,
            }),
    },
  ].filter((change) => change.value !== '');
}

function formatVenue(
  venue: PostingLoadEditsVenueDTO | null | undefined,
): string {
  return venue ? formatAddressLine(venue.zip, venue.city, venue.state) : '';
}
